import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UserApiService } from 'src/app/services/api/user-api.service';

@Component({
  selector: 'app-wallet-info-modal',
  templateUrl: './wallet-info-modal.component.html',
  styleUrls: ['./wallet-info-modal.component.scss'],
})
export class WalletInfoModalComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<WalletInfoModalComponent>,
    private api: UserApiService
  ) {}

  close(r: any = null) {
    this.dialogRef.close(r);
  }

  ngOnInit(): void {
    this.getUserAffiliate();
  }

  loading = false;
  data: any;
  async getUserAffiliate() {
    try {
      this.loading = true;
      const r = await this.api.getUserAffiliate();
      this.data = r.data;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
